// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__I3kKn","modalContent":"Modal_modalContent__hKfGx","closeButton":"Modal_closeButton__l4PYd"};